"use client";

interface ViewerLoaderProps {
  className?: string;
}

export function ViewerLoader({ className = "" }: ViewerLoaderProps) {
  return (
    <>
      <style>{`
        @keyframes viewer-loader-pulse {
          0%, 100% { opacity: 0.5; transform: scale(0.97); }
          50%      { opacity: 1;   transform: scale(1); }
        }
        @keyframes viewer-loader-sweep {
          0%   { transform: translateY(100%); }
          50%  { transform: translateY(0%); }
          100% { transform: translateY(100%); }
        }
      `}</style>
      <div
        className={`flex flex-col items-center justify-center gap-[18px] text-text-muted text-[13px] tracking-[0.02em] font-body ${className}`}
      >
        <svg
          viewBox="0 0 239.1 340.7"
          width={56}
          height={56}
          style={{ animation: "viewer-loader-pulse 2s ease-in-out infinite" }}
          aria-hidden="true"
        >
          <defs>
            <clipPath id="viewer-loader-logo">
              <path d="M184.5,6.6c-4.2-4.2-10-6.6-16-6.6H23.7C10.6,0,0,10.6,0,23.7V317c0,13.1,10.6,23.7,23.7,23.7h191.7c13.1,0,23.7-10.6,23.7-23.7V170.3l0.2-98.8c0-6-2.4-11.8-6.6-16L184.5,6.6z M24.4,36.3l165.3,121.8H24.4V36.3z M24.4,316.3V194.5l165.3,121.8H24.4z M214.7,304.3L49.3,182.5h165.4V304.3z M214.7,146.2L49.3,24.4h111v54.3h54.5L214.7,146.2z" />
            </clipPath>
          </defs>
          <path
            d="M184.5,6.6c-4.2-4.2-10-6.6-16-6.6H23.7C10.6,0,0,10.6,0,23.7V317c0,13.1,10.6,23.7,23.7,23.7h191.7c13.1,0,23.7-10.6,23.7-23.7V170.3l0.2-98.8c0-6-2.4-11.8-6.6-16L184.5,6.6z M24.4,36.3l165.3,121.8H24.4V36.3z M24.4,316.3V194.5l165.3,121.8H24.4z M214.7,304.3L49.3,182.5h165.4V304.3z M214.7,146.2L49.3,24.4h111v54.3h54.5L214.7,146.2z"
            fill="currentColor"
            opacity={0.15}
          />
          <g clipPath="url(#viewer-loader-logo)">
            <rect
              x={0}
              y={0}
              width={239.1}
              height={340.7}
              fill="var(--color-bubblegum)"
              opacity={0.7}
              style={{
                animation: "viewer-loader-sweep 2s ease-in-out infinite"
              }}
            />
          </g>
        </svg>
        <div role="status" aria-live="polite" className="sr-only">
          Loading 3D…
        </div>
      </div>
    </>
  );
}
